// src/components/ProtectedRoute.jsx
import { Navigate, useLocation } from "react-router-dom";

function normalizePerms(source) {
  if (!Array.isArray(source)) return [];
  return source
    .map((p) => (typeof p === "string" ? p : p?.name))
    .filter(Boolean)
    .map((s) => s.toLowerCase());
}

export default function ProtectedRoute({ requiredPermissions = [], children }) {
  const location = useLocation();
  const token = localStorage.getItem("access_token");

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  let user = {};
  try {
    user = JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    user = {};
  }

  const perms = normalizePerms(
    user?.role?.permissions || user?.permissions || []
  );

  if (
    requiredPermissions.length &&
    !requiredPermissions.every((p) => perms.includes(p.toLowerCase()))
  ) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}
